import { createContext, useContext, useState, ReactNode } from 'react'

interface GeminiPanelContextType {
  isOpen: boolean
  openPanel: () => void
  closePanel: () => void
  togglePanel: () => void
}

const GeminiPanelContext = createContext<GeminiPanelContextType | undefined>(undefined)

export function GeminiPanelProvider({ children }: { children: ReactNode }) {
  const GEMINI_PANEL_VISIBLE_KEY = 'clnicl_gemini_panel_visible'
  
  const [isOpen, setIsOpenState] = useState(() => {
    const saved = localStorage.getItem(GEMINI_PANEL_VISIBLE_KEY)
    return saved !== null ? saved === 'true' : false
  })

  const setIsOpen = (open: boolean) => {
    setIsOpenState(open)
    localStorage.setItem(GEMINI_PANEL_VISIBLE_KEY, String(open))
  }

  const openPanel = () => setIsOpen(true)
  const closePanel = () => setIsOpen(false)
  const togglePanel = () => setIsOpen(!isOpen)

  return (
    <GeminiPanelContext.Provider
      value={{
        isOpen,
        openPanel,
        closePanel,
        togglePanel,
      }}
    >
      {children}
    </GeminiPanelContext.Provider>
  )
}

export function useGeminiPanel() {
  const context = useContext(GeminiPanelContext)
  if (context === undefined) {
    throw new Error('useGeminiPanel must be used within a GeminiPanelProvider')
  }
  return context
}






























